export enum MessageType {
  TEXT = 'text',
  JSON_TEMPLATE = 'json_template', // 为未来 LiquidJS 预留
}

export enum SenderRole {
  USER = 'user', //游玩用户:右
  SYSTEM = 'system', // 旁白/世界观
  AUTHOR = 'author', // 建卡作者:左
}

// 统一的消息实体，无论是历史记录还是当前流式生成的内容都转成这个
export interface UIMessage {
  id: string
  role: SenderRole
  type: MessageType
  content: string // 原始内容
  renderData?: unknown // 解析后的 JSON 数据（如果是模板渲染）
  choices?: UIChoice[] //仅渲染最新消息的UIChoice,历史消息没有Choice
  timestamp: string
  // Galgame 模式专用：是否已经“播放”完毕
  isRevealed?: boolean
}

export interface UIChoice {
  id: string
  text: string
  action: () => void // 点击后的回调
}

export type GalgameSegments = string[]
